<template>
  <select-cifra
    ref="select"
    :show-clear="true"
    :options="options"
    :loading="loading"
    :internal-search="false"
    label="text"
    track-by="id"
    @search-change="onSearch"
  >
  </select-cifra>
</template>

<script>
import { debounce } from 'lodash';
import axios from '../../libs/cifra/axios';

/*
Para los datos usamos por defecto formato select2:
{"results":[{"id":76211,"text":"Matemáticas"},{"id":55832,"text":"lengua"}]}
*/
export default {
  props: {
    url: { type: String, required: true },
    params: { type: Function, default: undefined },
  },
  data() {
    return {
      options: [],
      loading: false,
    };
  },
  methods: {
    onSearch(texto) {
      if (texto.length) {
        this.ajaxSearch(texto, this);
      }
    },
    ajaxSearch: debounce((texto, vm) => {
      vm.loading = true;

      let params = { q: texto };
      if (vm.params) {
        params = vm.params(texto);
      }

      axios.get(vm.url, { params }).then((result) => {
        vm.options = result.data.results;
        vm.loading = false;
      }).catch(() => {
        vm.loading = false;
      });
    }, 350),
    load() {
      this.ajaxSearch('', this);
    },
  },
};
</script>

<style lang="scss" scoped>

</style>
